export const formServicesArray = (form) => {
    return Object.keys(form.services || {}).filter(s => form.services[s]);
}

export const declOfNum = (number, titles) => {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export const returnOfAccompanyingDocumentsName = 'returnDocuments' //code 'Возврат сопроводительных документов'
export const returnParcelName = 'returnParcel' //code 'Доставка с возвратом'
export const loadingServiceName = 'loading'
export const unloadingServiceName = 'unloading'
export const lathingServiceName = 'lathing'
export const loadingUnloadingServiceName = 'loadingUnloading'
export const DOCUMENT_MAX_WEIGHT = 30
export const PRR_MAX_WEIGHT_DEFAULT = 30
export const PRR_SERVICE_CODES = [loadingServiceName, unloadingServiceName]
export const MATRIX_SERVICE_CODES = [loadingServiceName, unloadingServiceName, lathingServiceName]

export const servicesSignature = (form) => {
    return formServicesArray(form).slice().sort().join(',')
}

export const onlyMatrixServicesChanged = (previousSignature, nextSignature) => {
    const prev = (previousSignature || '').split(',').filter(Boolean)
    const next = (nextSignature || '').split(',').filter(Boolean)
    const prevOther = prev.filter(s => !MATRIX_SERVICE_CODES.includes(s)).join(',')
    const nextOther = next.filter(s => !MATRIX_SERVICE_CODES.includes(s)).join(',')
    const prevMatrix = prev.filter(s => MATRIX_SERVICE_CODES.includes(s)).join(',')
    const nextMatrix = next.filter(s => MATRIX_SERVICE_CODES.includes(s)).join(',')
    return prevOther === nextOther && prevMatrix !== nextMatrix
}

export const customMatchingServices = (nameOfCurrentService, name, carrierCode) => {
    if (carrierCode !== 'CSE' && nameOfCurrentService === returnOfAccompanyingDocumentsName) {
        return name === returnParcelName;
    }

    return false;
}

export const tariffSupportsSelectedServices = (tariff, form) => {
    const serviceCodes = ((tariff && tariff.services) || []).map(s => s.code);
    const selected = formServicesArray(form).filter(s => s !== loadingUnloadingServiceName);
    return selected.every(s => serviceCodes.includes(s) || serviceCodes.some(sc => customMatchingServices(s, sc, tariff && tariff.carrierCode)));
}



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/utils.js